<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter" id="c01"><a class="hlink" href="#/OEBPS/9780062031716_epub_toc_r1.htm#c01">GETTING STARTED: IN THE MOOD FOR LOVE</a></h1>
<p class="nonindent">Romance—like the car keys, your birth certificate, and an empty taxi—is never there when you need it. The conventional wisdom is to get out there and meet people, which is great for the organizers of car maintenance courses and salsa classes; but don’t sign on the dotted line unless you are really fascinated by carburetors or enjoy close proximity to new varieties of aftershave. Far better to join a nunnery or sign up for a six-month stint on Mount Athos, where no woman has set foot in thousands of years, because the only guarantee is that when you do find love, it will be when you least expect it.</p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Futility</em></span><br/><br/></p>
<p class="nonindent">It is silly—</p>
<p class="nonindent">This waiting for love</p>
<p class="nonindent">In a parlour,</p>
<p class="nonindent">When love is singing up and down the alley</p>
<p class="nonindent">Without a collar.<br/><br/></p>
<p class="nonindent"><span class="small">Helene Johnson</span></p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Where the Single Men Go in Summer</em></span></p>
<p class="extract">There is an island in a far-off sea,<br/>Well hid, for to divulge its latitude were treason,<br/>Whereto in swallow-flocks, and silently,<br/>The single men migrate in summer season. The millions of single men, having fled all year,<br/>Come to this island utterly exhausted,<br/>Murmur a brief thanksgiving on the pier, Then breakfast on peanut butter and a chocolate<br/>Frosted.<br/>They tell male stories in the idioms of all nations,<br/>Listen to ball games on the radio,<br/>Hear minstrels celebrate the consummations<br/>Of remarkable business deals. They never go<br/>Away from this sanctuary till the season’s sped.<br/>In the summer hotels all over the world, the sad single girls<br/>Wait in vain<br/>For the One—personable, solvent, unwed—<br/>Who might, but never does, arrive on the next train.<br/><br/></p>
<p class="nonindent"><span class="small">Nina Bourne</span></p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Green Velvet Suit</em></span></p>
<p class="extract">She was on the tube<br/>I got on at Charing Cross<br/>And like everyday<br/>She didn’t look at me<br/>I even had a Green Velvet Suit<br/>And a yellow bow tie<br/>To make myself even more noticed<br/>I dyed my hair really red</p>
<p class="extract">And I hope tomorrow<br/>She will give me a glance<br/>It’s my very last chance<br/>For the long week-end<br/><br/></p>
<p class="nonindent"><span class="small">Alvaro</span></p>
<p class="pagebreak"> </p>
<p class="nonindent"><span class="big1"><em>Bloody Men</em></span></p>
<p class="extract">Bloody men are like bloody buses—<br/>You wait for about a year—<br/>And as soon as one approaches your stop<br/>Two or three others appear.</p>
<p class="extract">You look at them flashing their indicators,<br/>Offering you a ride.<br/>You’re trying to read the destinations,<br/>You haven’t much time to decide.</p>
<p class="extract">If you make a mistake, there is no turning back.<br/>Jump off, and you’ll stand there and gaze<br/>While the cars and taxis and lorries go by<br/>And the minutes, the hours, the days.<br/><br/></p>
<p class="nonindent"><span class="small">Wendy Cope</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062031716_epub_c01_r1.vue?e5f15bd2